var focusHelper = require("base/components/focus");
const $body = $("body");
const { showMiniCartError } = require("../components/cartHelper");

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($("#quickViewModal").hasClass("show") && !$(".product-set").length) {
        pid = $($el).closest(".modal-content").find(".product-quickview").data("pid");
    } else if ($(".product-set-detail").length || $(".product-set").length) {
        pid = $($el).data("pid");
    } else {
        pid = $(".product-detail:not('.bundle-item')").data("pid");
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $(".set-items").length) {
        quantitySelected = $($el).closest(".product-detail").find(".quantity-select");
    } else if ($(".c-personalization-modal.show").length) {
        quantitySelected = $(".c-personalization-modal.show").find(".quantity-select");
    } else if ($el && $(".product-detail-content").length) {
        var $productDetailContentQtySelect = $el.find(".product-detail-content .quantity-select");
        var $closestProductDetailContentQtySelect = $el.closest(".product-detail-content").find(".quantity-select");
        var $closestProductDetailContentQtyInput = $el.closest(".product-detail-content").find(".quantity-input");
        var $closestStickyProductDetailContentQtySelect = $el
            .closest(".product-detail-sticky")
            .siblings()
            .find(".product-detail-content .quantity-select");

        if ($closestProductDetailContentQtyInput.length) {
            quantitySelected = $closestProductDetailContentQtyInput;
        } else if ($productDetailContentQtySelect.length) {
            quantitySelected = $productDetailContentQtySelect;
        } else if ($closestProductDetailContentQtySelect.length) {
            quantitySelected = $closestProductDetailContentQtySelect;
        } else if ($closestStickyProductDetailContentQtySelect.length) {
            quantitySelected = $closestStickyProductDetailContentQtySelect;
        }
    }

    return quantitySelected ? quantitySelected : $(".quantity-select");
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            "[data-attr='" + attr.id + "'] [data-attr-value='" + attrValue.value + "']",
        );
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass("selected");
            $attrValue.siblings(".selected-assistive-text").text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass("selected");
            $attrValue.siblings(".selected-assistive-text").empty();
        }

        if (attrValue.url) {
            $swatchButton.attr("data-url", attrValue.url);
        } else {
            $swatchButton.removeAttr("data-url");
        }

        // Disable if not selectable
        $attrValue.removeClass("selectable unselectable");

        $attrValue.addClass(attrValue.selectable ? "selectable" : "unselectable");
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = "[data-attr='" + attr.id + "']";
    var $defaultOption = $productContainer.find($attr + " .select-" + attr.id + " option:first");
    $defaultOption.attr("value", attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find($attr + " [data-attr-value='" + attrValue.value + "']");
        $attrValue.attr("value", attrValue.url).removeAttr("disabled");

        if (!attrValue.selectable) {
            $attrValue.attr("disabled", true).closest(".form-group").addClass("d-none");
        } else {
            $attrValue.closest(".form-group").removeClass("d-none");
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ["color"];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return "";
    }

    var html = "";

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === "mainAttributes") {
            attributeGroup.attributes.forEach(function (attribute) {
                html += "<div class='attribute-values'>" + attribute.label + ": " + attribute.value + "</div>";
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find(".product-options").empty().html(optionsHtml);
}

/**
 * Disable main CTA if product has no stock
 * @param {Object} - product
 */
function handleCTAState(product) {
    if (!product.availabilityInfo.isInStock) {
        $(".js-add-to-cart-main .add-to-cart").attr("disabled", true).addClass("preorder-not-available");
    }
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents(".choose-bonus-product-dialog").length > 0;
    var isVariant;
    var quantityPrice = response.product.quantityPrice;
    var originalQuantityPrice = response.product.originalQuantityPrice;
    var discountValue = response.product.price?.discount?.value;
    var $priceWrapper = $productContainer.find(".add-to-cart .prices");
    var originalPriceWrapperSelector = ".original-price-wrapper";
    var $originalPriceWrapper = $productContainer.find(originalPriceWrapperSelector).length
        ? $productContainer.find(originalPriceWrapperSelector)
        : $(`.product-detail[data-pid='${response.product.id}']`).find(originalPriceWrapperSelector);
    var $originalPrice = $originalPriceWrapper.find(".original-price");
    var $originalDiscountPercentage = $originalPriceWrapper.find(".discount-percentage");

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === "variant";
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent(".bonus-product-item").data("pid", response.product.id);

            $productContainer.parent(".bonus-product-item").data("ready-to-order", response.product.readyToOrder);
        }
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $(".prices .price", $productContainer).length
            ? $(".prices .price", $productContainer)
            : $(".prices .price");
        var $pricePerLiterBlock = $productContainer.find(".pdp-price-per-liter-value");
        var pricePerLiterValue = response.product.pricePerLitre;

        $priceSelector.replaceWith(response.product.price.html);
        $priceWrapper.html(response.product.price.html);

        if (quantityPrice && $priceWrapper.length) {
            $priceWrapper.html(quantityPrice);
        }

        if ($originalPrice.length && $originalDiscountPercentage.length) {
            if (originalQuantityPrice && discountValue) {
                $originalPrice.text(originalQuantityPrice);
                $originalDiscountPercentage.text($originalDiscountPercentage.text().replace(/\d+/g, discountValue));
                $originalPriceWrapper.show();
            } else {
                $originalPriceWrapper.hide();
            }
        }

        if (pricePerLiterValue && $pricePerLiterBlock.length) {
            $pricePerLiterBlock.html(pricePerLiterValue);
        }
    }

    if (response.productSetData) {
        updateProductSetAddAllToCart(response.productSetData);
    }

    // Update promotions
    $productContainer.find(".promotions").empty().html(response.product.promotionsHtml);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find(".select-bonus-product");
        $selectButton.trigger("bonusproduct:updateSelectButton", {
            product: response.product,
            $productContainer: $productContainer,
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $("button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global")
            .trigger("product:updateAddToCart", {
                product: response.product,
                $productContainer: $productContainer,
            })
            .trigger("product:statusUpdate", response.product);
        handleCTAState(response.product);
    }

    // Update attributes
    $productContainer.find(".main-attributes").empty().html(getAttributesHtml(response.product.attributes));

    // Update nutrition info
    if (response.enableNutritionInfo) {
        const $nutri = $(".nutri");

        $.ajax({
            url: $("#productNutritionUrl").val(),
            method: "GET",
            data: {
                pid: response.product.id,
            },
            success: function (response) {
                $nutri.html(response);
                $nutri.show();
            },
            error: function () {
                $nutri.hide();
            },
        });
    } else {
        $(".nutri").hide();
    }
}

/**
 * @description Updates the text of the main CTA button and disabled it if there is not stock.
 * @param {Object} product -
 */
function updateCTA(product) {
    var availabilityInfo = product.availabilityInfo;
    var isMandatoryPersonalizable = product.personalization ? product.personalization.isCustoMandatory : false;
    var ctaLabel = availabilityInfo.ctaLabel;
    var buttonLabelFormated = ctaLabel.buttonLabelFormated;
    var hasStock = availabilityInfo.isInStock;
    var $CTABtn = $(`.js-add-to-cart-main .cart-and-ipay [data-pid=${product.id}]`);
    var $CTABDash = $CTABtn.find(".dash");
    var $CTABPrice = $CTABtn.find(".prices");
    var $preorderBox = $("#preorder-box");

    if (!availabilityInfo.isMyMHCellar) {
        $CTABtn.find(".add-to-cart-label").text(buttonLabelFormated);
    }

    $CTABtn.find("button").attr("data-product-ismandatorypersonalizable", isMandatoryPersonalizable);
    if (!hasStock) {
        $CTABDash.addClass("d-none");
        $CTABPrice.addClass("d-none");
    } else {
        $CTABDash.removeClass("d-none");
        $CTABPrice.removeClass("d-none");
    }
    if (
        $preorderBox &&
        !$preorderBox.hasClass("d-none") &&
        (ctaLabel.buttonLabel === "OutOfStock" || ctaLabel.buttonLabel === "AddToCart")
    ) {
        $preorderBox.addClass("d-none");
    }
    if (
        $preorderBox &&
        $preorderBox.hasClass("d-none") &&
        (ctaLabel.buttonLabel === "AvailableFrom" || ctaLabel.buttonLabel === "PreOrder")
    ) {
        var preOrdeReleaseDate = ctaLabel.preOrderReleaseDateFormated;
        var $releaseDate = $preorderBox.find(".preorder-date .js-date-formatted");
        $releaseDate.text(preOrdeReleaseDate);
        $preorderBox.removeClass("d-none");
    }
}

/**
 * Updates the enhanced quantity selector with the new values
 * @param {object} product - The product object
 * @param {object} targetElement - The target element
 * @param {object} $productContainer - DOM container for a given product
 */
function updateEnhancedQtySelector(product, targetElement, $productContainer) {
    if (product) {
        const maxOrderQuantity = product.maxOrderQuantity;
        const url = product.quantities && product.quantities.length > 0 && product.quantities[0].url;
        const ats = product.availabilityInfo && product.availabilityInfo.ats;
        const $selectEl = $productContainer.find(".product-detail-content .quantity-select");

        if ($selectEl.data("max-order-quantity") && $selectEl.data("ats")) {
            $selectEl.attr("data-max-order-quantity", maxOrderQuantity).data("max-order-quantity", maxOrderQuantity);
            $selectEl.attr("data-ats", ats).data("ats", ats);
            $selectEl.attr("data-url", url).data("url", url);

            if (targetElement && targetElement.length) {
                $body.trigger("enhancedQuantitySelector:init", "pdp");
                $body.trigger("enhancedQuantitySelector:updateSelectData", { $selectEl, maxOrderQuantity, ats });
            }
        }
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent(".bonus-product-item").length <= 0) {
        var optionsHtml = quantities
            .map(function (quantity) {
                var selected = quantity.selected ? " selected " : "";
                return (
                    "<option value='" +
                    quantity.value +
                    "'  data-url='" +
                    quantity.url +
                    "'" +
                    selected +
                    ">" +
                    quantity.value +
                    "</option>"
                );
            })
            .join("");

        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 * @param {object} targetElement - The target element
 */
function attributeSelect(selectedValueUrl, $productContainer, targetElement) {
    if (selectedValueUrl) {
        if ($productContainer.hasClass("set-item")) {
            let productSetId = $(".product-set-detail[data-pid]").attr("data-pid");
            let $siblings = $productContainer.siblings(".set-item");

            selectedValueUrl = selectedValueUrl.concat(`&productSetId=${productSetId}`);
            let productSetQuantityArray = [];
            $siblings.each(function () {
                const $element = $(this);
                const pid = $element.attr("data-pid");
                const qty = $element.find(".quantity-select").val();
                productSetQuantityArray.push({ pid, qty });
            });
            selectedValueUrl = selectedValueUrl.concat(
                `&productSetQuantityArray=${JSON.stringify(productSetQuantityArray)}`,
            );
        }

        $("body").trigger("product:beforeAttributeSelect", { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: "GET",
            success: function (data) {
                if (data !== undefined && data.product !== undefined) {
                    const $quantitySelect = $(".js-quantity-wrapper > .custom-select-wrapper");
                    const $addToCartButton = $(".js-add-to-cart-main .add-to-cart");
                    const $outOfStockButton = $(".js-add-to-cart-main .btn-out-of-stock");

                    updateCTA(data.product);
                    handleVariantResponse(data, $productContainer);
                    updateOptions(data.product.optionsHtml, $productContainer);
                    updateQuantities(data.product.quantities, $productContainer);
                    updateEnhancedQtySelector(data.product, targetElement, $productContainer);
                    updateSwatchElements(data.product, $productContainer);
                    data.updateImgCarousel = targetElement && targetElement.length;

                    // update the elements client side
                    if (data.product.availabilityInfo && data.product.availabilityInfo.isMyMHCellar) {
                        $("[data-product-pid]").attr("data-product-pid", data.product.id);

                        if (!data.product.availabilityInfo.quantitiesAvailable) {
                            $quantitySelect.addClass("d-none");
                            $addToCartButton.addClass("d-none");
                            $outOfStockButton.removeClass("d-none");
                        } else {
                            $quantitySelect.removeClass("d-none");
                            $addToCartButton.removeClass("d-none");
                            $outOfStockButton.addClass("d-none");
                        }
                    }
                }

                $("body").trigger("product:afterAttributeSelect", { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
        });
    }
}

/**
 * Updates the swatch elements on the product page
 * @param {Object} product - the product data object
 * @param {jQuery} $productContainer - DOM element for current product
 * @returns {void}
 */
function updateSwatchElements(product, $productContainer) {
    // Hide shipping options PDP level
    $productContainer.find(".add-to-cart").toggleClass("d-none", product.hideShoppingOption);
    $(".prices-add-to-cart-actions, .caseof-variations, .quantity").toggleClass("d-none", product.hideShoppingOption);

    // Get all swatch line items
    var $swatchLineItems = getSwatchLineItems($productContainer);
    var firstLineItem = $swatchLineItems.eq(0);
    var secondLineItem = $swatchLineItems.eq(1);
    // Update case for single line item
    if ($swatchLineItems.length === 1) {
        firstLineItem.find(".perbottle-price,.variation-small-price").text("");
        firstLineItem.find(".perbottle-price").text(product.price.sales.formatted);
    }

    // Update case for two line items
    if (
        (product.variationAttributes &&
            product.variationAttributes.length === 2 &&
            product.typeValue === "CASE" &&
            $swatchLineItems.length === 2) ||
        (product.typeValue === "BOTTLE" && product.variationAttributes)
    ) {
        product.variationAttributes[0].values.forEach(function (value) {
            if (value.selectable === true && $swatchLineItems.length) {
                // Fallback on main product if not available
                var bottlePrice = value.bottlePrice || product.price.sales.formatted;
                // Remove previous values
                $swatchLineItems.find(".perbottle-price,.variation-small-price").text("");
                // Update per bottle text
                firstLineItem.find(".perbottle-price").text(bottlePrice + " " + value.perBottleString);
                // Update per case text
                secondLineItem.find(".perbottle-price").text(value.caseOfPrice + " " + value.perCaseString);
                secondLineItem
                    .find(".variation-small-price")
                    .text(value.caseOfBottlePrice + " " + value.perBottleString);
                // Count line items after update
                var $updatedSwatchLineItems = getSwatchLineItems($productContainer);
                // Update swatch PLI values
                if (value.attr === "caseSize" && $updatedSwatchLineItems.length === 2) {
                    if (displayLineItem(value, product, "bottle")) {
                        // Hide bottle line
                        firstLineItem.addClass("d-none");
                    } else if (displayLineItem(value, product, "caseof")) {
                        // Hide case line
                        secondLineItem.addClass("d-none");
                    } else {
                        firstLineItem.removeClass("d-none");
                        secondLineItem.removeClass("d-none");
                    }
                }
            }
        });
    }
}

/**
 * Updates the product set add all to cart button
 * @param {object} productSetData - the product set data object
 * @param {string} productSetData.totalValue - the total value of the product set
 * @param {boolean} productSetData.isAvailable - true if all products from the product set are available for purchase
 */
function updateProductSetAddAllToCart(productSetData) {
    let { totalValue, isAvailable } = productSetData;
    let $addAllToCartPriceBtn = $(".product-set-add-to-cart .add-to-cart");
    let $addAllToCartPriceLabel = $addAllToCartPriceBtn.find(".prices");

    if (!isAvailable) {
        $addAllToCartPriceBtn.attr("disabled");
    }

    if (totalValue) {
        $addAllToCartPriceLabel.text(totalValue);
    }
}

/**
 * Returns the swatch line items from a given container
 * @param {object} $container - jQuery DOM element container
 * @returns {object} - the swatch line items from the given container
 */
function getSwatchLineItems($container) {
    return $container.find(".m-bottle:not(.d-none),.m-caseof:not(.d-none),.m-no-type:not(.d-none)");
}

/**
 * Checks if a line item should be displayed
 * @param {Object} value - the line item object
 * @param {Object} product - the product object
 * @param {string} type - the type of line item
 * @returns {boolean} - whether the line item should be displayed
 */
function displayLineItem(value, product, type) {
    return (
        ((value.hideShoppingOption && !product.hideShoppingOption) ||
            (!value.independentlySellable && !product.independentlySellable)) &&
        value.type === type
    );
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(".add-to-cart-url").val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var body = $html.find(".choice-of-bonus-product");
    var footer = $html.find(".modal-footer").children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(".modal-body").spinner().start();

    if ($("#chooseBonusProductModal").length !== 0) {
        $("#chooseBonusProductModal").remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString =
        "<!-- Modal -->" +
        "<div class='modal fade' id='chooseBonusProductModal' tabindex='-1' role='dialog'>" +
        "<span class='enter-message sr-only'></span>" +
        "<div class='modal-dialog choose-bonus-product-dialog'" +
        "data-total-qty='" +
        data.maxBonusItems +
        "'" +
        "data-UUID='" +
        data.uuid +
        "'" +
        "data-pliUUID='" +
        data.pliUUID +
        "'" +
        "data-addToCartUrl='" +
        data.addToCartUrl +
        "'" +
        "data-pageStart='0'" +
        "data-pageSize='" +
        data.pageSize +
        "'" +
        "data-moreURL='" +
        data.showProductsUrlRuleBased +
        "'" +
        "data-bonusChoiceRuleBased='" +
        data.bonusChoiceRuleBased +
        "'>" +
        "<!-- Modal content-->" +
        "<div class='modal-content'>" +
        "<div class='modal-header'>" +
        "    <span class=''>" +
        data.labels.selectprods +
        "</span>" +
        "    <button type='button' class='close pull-right' data-dismiss='modal'>" +
        "        <span aria-hidden='true'>&times;</span>" +
        "        <span class='sr-only'> </span>" +
        "    </button>" +
        "</div>" +
        "<div class='modal-body'></div>" +
        "<div class='modal-footer'></div>" +
        "</div>" +
        "</div>" +
        "</div>";
    $("body").append(htmlString);
    $(".modal-body").spinner().start();

    $.ajax({
        url: bonusUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $("#chooseBonusProductModal .modal-body").empty();
            $("#chooseBonusProductModal .enter-message").text(response.enterDialogMessage);
            $("#chooseBonusProductModal .modal-header .close .sr-only").text(response.closeButtonText);
            $("#chooseBonusProductModal .modal-body").html(parsedHtml.body);
            $("#chooseBonusProductModal .modal-footer").html(parsedHtml.footer);
            $("#chooseBonusProductModal").modal("show");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        },
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
var timer;
function handlePostCartAdd(response) {
    const $minicart = $(".minicart");
    const $header = $(".page-header");
    const $minicartPopover = $header.find(".minicart-popover");
    const messageType = response.error ? "alert-danger" : "alert-success";

    clearTimeout(timer);
    $minicart.trigger("count:update", response);

    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if (!response.error) {
            $minicart.find(".minicart-total").click();
        }
        var $addToCartMsg = $(".add-to-cart-messages");

        if ($addToCartMsg.length === 0) {
            $("body").append("<div class='add-to-cart-messages'></div>");
        }

        $(".add-to-cart-messages")
            .empty()
            .append(
                "<div class='alert " + messageType + " add-to-basket-alert text-center' role='alert'>" + response.message + "</div>",
            );

        if (response.quantityTotal === 0 && response.error) {
            $(".error-messages").empty().append(response.message);
        }

        var observer = new MutationObserver(function () {
            if (response && response.error) {
                showMiniCartError($minicartPopover, response.message);
            }
        });

        observer.observe($minicartPopover[0], { childList: true });

        timer = setTimeout(function () {
            $(".add-to-basket-alert").remove();
            $minicartPopover.find(".minicart-close-button").click();
            $minicartPopover.find(".valid-cart-error").empty();
            observer.disconnect();
        }, 5000);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $(".bundle-item").each(function () {
        childProducts.push({
            pid: $(this).find(".product-id").text(),
            quantity: parseInt($(this).find("label.quantity").attr("data-quantity"), 10),
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find(".product-option")
        .map(function () {
            var $elOption = $(this).find(".options-select");
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find("option[value='" + urlValue + "']").data("value-id");
            return {
                optionId: $(this).data("option-id"),
                selectedValueId: selectedValueId,
            };
        })
        .toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            },
        });
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        },
    },

    focusChooseBonusProductModal: function () {
        $("body").on("shown.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "true");
            $("#chooseBonusProductModal .close").focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $("body").on("hidden.bs.modal", "#chooseBonusProductModal", function () {
            $("#chooseBonusProductModal").siblings().attr("aria-hidden", "false");
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $("body").on("keydown", "#chooseBonusProductModal", function (e) {
            var focusParams = {
                event: e,
                containerSelector: "#chooseBonusProductModal",
                firstElementSelector: ".close",
                lastElementSelector: ".add-bonus-products",
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    colorAttribute: function () {
        $(document).on("click", "[data-attr='color'] button", function (e) {
            e.preventDefault();

            if ($(this).attr("disabled")) {
                return;
            }
            var $productContainer = $(this).closest(".set-item");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".product-detail");
            }

            attributeSelect($(this).attr("data-url"), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on(
            "change",
            "select[class*='select-'], .options-select, input[name*='variation-group']",
            function (e) {
                e.preventDefault();

                var $this = $(this);
                var $productContainer = $this.closest(".set-item");
                if (!$productContainer.length) {
                    $productContainer = $this.closest(".product-detail");
                }
                attributeSelect(e.currentTarget.value, $productContainer, $this);

                if ($this.hasClass("caseof-input") && $this.parents(".caseof-wrapper")) {
                    $(".caseof-wrapper").toggleClass("selected");
                }
            },
        );
    },

    availability: function () {
        $(document).on("change", ".quantity-select", function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest(".product-detail");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".modal-content").find(".product-quickview");
            }

            if (!$productContainer.length && $(this).closest(".personalization-dialog").length) {
                $productContainer = $(".product-detail.product-wrapper");
            }

            if ($(".bundle-items", $productContainer).length === 0) {
                let dataURL =
                    $(e.currentTarget).find("option:selected").attr("data-url") || $(e.currentTarget).attr("data-url");
                let currentOptionValue = $(e.currentTarget).find("option:selected").val();

                if (dataURL) {
                    dataURL.replace(/quantity=\d+/, "quantity=" + currentOptionValue);
                }

                attributeSelect(dataURL, $productContainer);
            }
        });
    },

    addToCart: function () {
        $(document).on("click", "button.add-to-cart, button.add-to-cart-global", function () {
            var $this = $(this);
            if ($this.closest(".suggested-product").length || $this.parents(".product-tile").length) {
                return;
            }

            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var isMandatoryPersonalizable = $this.data("product-ismandatorypersonalizable");

            if ($(".product-detail").length && isMandatoryPersonalizable) {
                $.spinner().start();
                $("[data-target-personalization-modal]").trigger("click");
                return;
            }

            $("body").trigger("product:beforeAddToCart", this);

            if ($(".set-items").length && $this.parent().hasClass("product-set-add-to-cart")) {
                setPids = [];

                $(".product-detail").each(function () {
                    if (!$(this).hasClass("product-set-detail")) {
                        setPids.push({
                            pid: $(this).attr("data-pid"),
                            qty: $(this).find(".quantity-select").val(),
                            options: getOptions($(this)),
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest(".product-detail");
            if (!$productContainer.length) {
                $productContainer = $(this).closest(".quick-view-dialog").find(".product-detail");
            }

            addToCartUrl = getAddToCartUrl();
            var csrfToken = $("input[id='add-to-cart-csrf-token'").val();
            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this)),
                csrf_token: csrfToken,
            };

            if (!$(".bundle-item").length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger("updateAddToCartFormData", form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: "POST",
                    data: form,
                    success: function (data) {
                        $body.trigger("product:afterAddToCart", data);
                        handlePostCartAdd(data);
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);

                        const updatedProductData = data.cart.items.find((item) => String(item.id) === String(pid));
                        // Update quantity dropdown on PDP
                        $body.trigger("enhancedQuantitySelector:updateSelectorMaxVal", {
                            maxOrderQuantity: updatedProductData.maxRemainingQuotaOrderQuantity,
                            page: "pdp",
                        });

                        if (data.availabilityInfo && data.availabilityInfo.isMyMHCellar) {
                            const $productActionWrapper = $("[data-product-pid]");
                            if (!updatedProductData.maxRemainingQuotaOrderQuantity) {
                                $productActionWrapper
                                    .find(".js-quantity-wrapper > .custom-select-wrapper")
                                    .addClass("d-none");
                                $productActionWrapper.find(".add-to-cart").addClass("d-none");
                                $productActionWrapper.find(".btn-out-of-stock").removeClass("d-none");
                            }
                            $productActionWrapper.find(`.add-to-cart[data-pid=${updatedProductData.id}] .prices `).text(updatedProductData.price.sales.formatted);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on("click", ".select-bonus-product", function () {
            var $choiceOfBonusProduct = $(this).parents(".choice-of-bonus-product");
            var pid = $(this).data("pid");
            var maxPids = $(".choose-bonus-product-dialog").data("total-qty");
            var submittedQty = parseInt($choiceOfBonusProduct.find(".bonus-quantity-select").val(), 10);
            var totalQty = 0;
            $.each($("#chooseBonusProductModal .selected-bonus-products .selected-pid"), function () {
                totalQty += $(this).data("qty");
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find(".product-option").data("option-id");
            var valueId = $choiceOfBonusProduct.find(".options-select option:selected").data("valueId");
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml =
                    "" +
                    "<div class='selected-pid row'" +
                    "data-pid='" +
                    pid +
                    "'" +
                    "data-qty='" +
                    submittedQty +
                    "'" +
                    "data-optionID='" +
                    (optionID || "") +
                    "'" +
                    "data-option-selected-value='" +
                    (valueId || "") +
                    "'" +
                    ">" +
                    "<div class='col-sm-11 col-9 bonus-product-name'>" +
                    $choiceOfBonusProduct.find(".product-name").html() +
                    "</div>" +
                    "<div class='col-1'><i class='fa fa-times' aria-hidden='true'></i></div>" +
                    "</div>";
                $("#chooseBonusProductModal .selected-bonus-products").append(selectedBonusProductHtml);
                $(".pre-cart-products").html(totalQty);
                $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
            } else {
                $(".selected-bonus-products .bonus-summary").addClass("alert-danger");
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on("click", ".selected-pid", function () {
            $(this).remove();
            var $selected = $("#chooseBonusProductModal .selected-bonus-products .selected-pid");
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data("qty"), 10);
                });
            }

            $(".pre-cart-products").html(count);
            $(".selected-bonus-products .bonus-summary").removeClass("alert-danger");
        });
    },
    enableBonusProductSelection: function () {
        $("body").on("bonusproduct:updateSelectButton", function (e, response) {
            $("button.select-bonus-product", response.$productContainer).attr(
                "disabled",
                !response.product.readyToOrder || !response.product.available,
            );
            var pid = response.product.id;
            $("button.select-bonus-product", response.$productContainer).data("pid", pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on("click", ".show-more-bonus-products", function () {
            var url = $(this).data("url");
            $(".modal-content").spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $(".modal-body").append(parsedHtml.body);
                    $(".show-more-bonus-products:first").remove();
                    $(".modal-content").spinner().stop();
                },
                error: function () {
                    $(".modal-content").spinner().stop();
                },
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on("click", ".add-bonus-products", function () {
            var $readyToOrderBonusProducts = $(".choose-bonus-product-dialog .selected-pid");
            var queryString = "?pids=";
            var url = $(".choose-bonus-product-dialog").data("addtocarturl");
            var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
            var pidsObject = {
                bonusProducts: [],
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this).data("qty"), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data("optionid") && $(this).data("option-selected-value")) {
                        option = {};
                        option.optionId = $(this).data("optionid");
                        option.productId = $(this).data("pid");
                        option.selectedValueId = $(this).data("option-selected-value");
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data("pid"),
                        qty: qtyOption,
                        options: [option],
                    });
                    pidsObject.totalQty = parseInt($(".pre-cart-products").html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + "&uuid=" + $(".choose-bonus-product-dialog").data("uuid");
            queryString = queryString + "&pliuuid=" + $(".choose-bonus-product-dialog").data("pliuuid");
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: "POST",
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $("#chooseBonusProductModal").modal("hide");
                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class='add-to-cart-messages'></div>");
                        }
                        $(".add-to-cart-messages").append(
                            "<div class='alert alert-danger add-to-basket-alert text-center'" +
                                " role='alert'>" +
                                data.errorMessage +
                                "</div>",
                        );
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                        }, 3000);
                    } else {
                        $(".configure-bonus-product-attributes").html(data);
                        $(".bonus-products-step2").removeClass("hidden-xl-down");
                        $("#chooseBonusProductModal").modal("hide");

                        if ($(".add-to-cart-messages").length === 0) {
                            $("body").append("<div class='add-to-cart-messages'></div>");
                        }
                        var $minicartQty = data.totalQty < 100 ? data.totalQty : $minicartQtyResource;
                        $(".minicart-quantity").html($minicartQty);
                        $(".add-to-cart-messages").append(
                            "<div class='alert alert-success add-to-basket-alert text-center'" +
                                " role='alert'>" +
                                data.msgSuccess +
                                "</div>",
                        );
                        setTimeout(function () {
                            $(".add-to-basket-alert").remove();
                            if ($(".cart-page").length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                },
            });
        });
    },

    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
};
